import { __extends } from "tslib";
import { isFunction } from './util/isFunction';
import { empty as emptyObserver } from './Observer';
import { Subscription, isSubscription } from './Subscription';
import { config } from './config';
import { hostReportError } from './util/hostReportError';
var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch (arguments.length) {
            case 0:
                _this.destination = emptyObserver;
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = emptyObserver;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    }
                    else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
        }
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    return Subscriber;
}(Subscription));
export { Subscriber };
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        if (isFunction(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== emptyObserver) {
                var context_1;
                if (config.useDeprecatedNextContext) {
                    context_1 = Object.create(observerOrNext);
                    context_1.unsubscribe = _this.unsubscribe.bind(_this);
                }
                else {
                    context_1 = observerOrNext;
                }
                next = next && next.bind(context_1);
                error = error && error.bind(context_1);
                complete = complete && complete.bind(context_1);
                if (isSubscription(observerOrNext)) {
                    observerOrNext.add(_this.unsubscribe.bind(_this));
                }
            }
        }
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            try {
                this._next(value);
            }
            catch (err) {
                this._throw(err);
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            if (this._error) {
                try {
                    this._error(err);
                }
                catch (err) {
                    this._throw(err);
                    return;
                }
                this.unsubscribe();
            }
            else {
                this._throw(err);
            }
        }
    };
    SafeSubscriber.prototype._throw = function (err) {
        this.unsubscribe();
        if (config.useDeprecatedSynchronousErrorHandling) {
            var _parentSubscriber = this._parentSubscriber;
            if (_parentSubscriber === null || _parentSubscriber === void 0 ? void 0 : _parentSubscriber.syncErrorThrowable) {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
            }
            else {
                throw err;
            }
        }
        else {
            hostReportError(err);
        }
    };
    SafeSubscriber.prototype.complete = function () {
        if (!this.isStopped) {
            if (this._complete) {
                try {
                    this._complete();
                }
                catch (err) {
                    this._throw(err);
                    return;
                }
            }
            this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            var _parentSubscriber = this._parentSubscriber;
            this._parentSubscriber = null;
            _parentSubscriber.unsubscribe();
            _super.prototype.unsubscribe.call(this);
        }
    };
    return SafeSubscriber;
}(Subscriber));
export { SafeSubscriber };
//# sourceMappingURL=Subscriber.js.map